export enum MenuType {
    QuickLink = 'QuickLink',
    MenuLink = 'MenuLink'
}